import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles, TextField, Typography, MenuItem} from "@material-ui/core";
import t from "../../../languages/pl";
import { notArrayOrEmpty } from '../../../utils/helpers';
import guid from './../../../utils/guid';
import withSaveButton from './../../HOC/withSaveButton';
import { compose } from "recompose";

const useStyles = theme => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: 500
    },
    row: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        margin: theme.spacing(1)
    },
    textField: {
        width: 150
    }
});

const RentDefaultSettings = props => {
    const { classes, data, onChange } = props;
    const [updatedData, setUpdatedData] = useState(data);

    useEffect(() => {
        setUpdatedData(data);
        props.onFormDataChange(data);
    }, [data]);

    useEffect(() => {
        props.onFormDataChange(updatedData);
        onChange && onChange(updatedData);
    }, [updatedData]);

    const printOptions = array => {
        if (notArrayOrEmpty(array))
            return;
        return array.map(option => (
            <MenuItem
                key={guid()}
                value={option}
            >
                {option}
            </MenuItem>
        ));
    };

    const handleValueChange = (e) => {
        e.persist();
        setUpdatedData(state => ({ ...state, [e.target.name]: e.target.value }));
    };

    const handleNumberChange = (e) => {
        e.persist();
        setUpdatedData(state => ({ ...state, [e.target.name]: parseInt(e.target.value) }));
    };

    return (
        <div className={classes.container}>
            <Typography variant="subtitle1">
                {t.defaultSettingsForRents}
            </Typography>
            <div className={classes.row}>
                <TextField
                    label={t.lumpSumPln}
                    className={classes.textField}
                    type="number"
                    name="ryczalt_kwota"
                    value={updatedData.ryczalt_kwota}
                    onChange={(e) => handleValueChange(e)}
                />
                <TextField
                    label={t.accrualPeriod}
                    className={classes.textField}
                    select
                    name="ryczalt_rodzaj"
                    value={updatedData.ryczalt_rodzaj}
                    onChange={(e) => handleValueChange(e)}
                >
                    <MenuItem value=""><em>{t.pick}</em></MenuItem>
                    {printOptions(updatedData.rodzaj_ryczalt_opcje)}
                </TextField>
            </div>
            <div className={classes.row}>
                <TextField
                    label={t.kilometersLimit}
                    className={classes.textField}
                    type="number"
                    name="limitkm"
                    value={updatedData.limitkm}
                    onChange={e => handleNumberChange(e)}
                />
                <TextField
                    label={t.kilometersLimitPeriod}
                    className={classes.textField}
                    select
                    name="limitkm_rodzaj"
                    value={updatedData.limitkm_rodzaj}
                    onChange={(e) => handleValueChange(e)}
                >
                    <MenuItem value=""><em>{t.pick}</em></MenuItem>
                    {printOptions(updatedData.limitkm_rodzaj_opcje)}
                </TextField>
            </div>
            <div className={classes.row}>
                <Typography variant="body1">
                    {t.rateAfterLimitExceeded}
                </Typography>
                <TextField
                    label={t.rate}
                    className={classes.textField}
                    value={updatedData.stawka_km}
                    type="number"
                    name="stawka_km"
                    onChange={(e) => handleValueChange(e)}
                />
            </div>
            <div style={{ width: "100%" }}>
                <TextField
                    label={t.description}
                    fullWidth
                    value={updatedData.opis}
                    name="opis"
                    onChange={(e) => handleValueChange(e)}
                />
            </div>
        </div>
    );
};

RentDefaultSettings.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    onChange: PropTypes.func,
    //withSaveButton
    onFormDataChange: PropTypes.func
};

export default compose(
    withStyles(useStyles),
    withSaveButton
)(RentDefaultSettings);